module.exports = __webpack_public_path__ + "static/img/qq_7.40da4b93.png";